<label *ngIf="to.label" class="block text-sm font-medium text-gray-700 mb-2">
  {{ to.label }}
</label>

<div *ngFor="let field of field.fieldGroup; let i = index" class="ml-6 mb-4">
  <formly-field [field]="field"></formly-field>
  <button type="button" class="btn btn-sm mt-2 text-sm min-w-[24px]" (click)="remove(i)">
    {{ to['removeText'] || '-' }}
  </button>
</div>

<button
  type="button"
  class="btn btn-sm btn-primary mt-2 text-sm min-w-[24px]"
  [class.ml-6]="field.fieldGroup?.length"
  (click)="add()"
>
  {{ to['addText'] || '+' }}
</button>
